import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      text: 'SSL Encrypted',
      color: 'var(--color-success)'
    },
    {
      icon: 'Lock',
      text: 'Secure Login',
      color: 'var(--color-primary)'
    },
    {
      icon: 'CheckCircle',
      text: 'Verified Platform',
      color: 'var(--color-accent)'
    }
  ];

  return (
    <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 lg:gap-8">
      {securityFeatures?.map((feature, index) => (
        <div 
          key={index}
          className="flex items-center gap-2"
        >
          <div 
            className="w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: `${feature?.color}15` }}
          >
            <Icon 
              name={feature?.icon} 
              size={18} 
              color={feature?.color}
            />
          </div>
          <span className="text-xs md:text-sm text-muted-foreground font-medium">
            {feature?.text}
          </span>
        </div>
      ))}
    </div>
  );
};

export default SecurityBadges;